<template>
  <div id="list_container" class="bg-white">
    <div class="print-header"><img src="images/print_logo.png" width="14%" height="14%" style="display: inline-block; vertical-align: baseline; line-height: .55in; margin-top:0px;margin-bottom:0px;"/><h3 style="display:inline-block; color: #382b2b;line-height: .69in; margin-top:0px;margin-bottom:0px;">&nbsp;Printed Copy</h3>
      <hr style="margin-top: -15px; margin-bottom: 0px;">
    </div>
    <iframe id="printFrame"></iframe>

    <!-- list view -->
    <div id="list_view" v-cloak  class="container-fluid fade-in flex-grow-1 d-print-none" :class="{'main-content-margin-top': !isPersonaView}">
      
      <div v-if="paginator.pageItems.length==0" class="row">
        <div class="col">
          <span v-if="!activeSearch" class="text-muted">Enter search values above</span>
          <span v-else class="text-muted">No results found</span>
        </div>
      </div>
      <div v-show="paginator.pageItems.length>0" class="row justify-content-around">
        <!-- main content -->
        <div class="col-8">
          <!-- campaign table container -->
          <div class="row">
            <div id="table_container" class="col campaign-table-container" :class="{'tbody-scroll': isPersonaView}">
              <table v-if="!isPersonaView" 
                id="tableApp" class="table table-hover table-striped table-sm campaign-table">
                <thead class="sortable-header">
                  <tr>
                    <th id="hdr_group_name" data-field="sent_dt" data-type="date" @click="sortRecords($event.target)" 
                      class="pb-2 text-nowrap col-a"
                      :class="[(sort.column=='sent_dt') ? sortClass : '', showLocalTimeStamp ? 'col-ts' : '']">
                      Sent
                    </th>
                    <th id="hdr_launch_date" data-field="from_name" data-type="text" @click="sortRecords($event.target)" 
                      class="pb-2 text-nowrap col-b d-none d-lg-table-cell d-xl-table-cell"
                      :class="[(sort.column=='from_name') ? sortClass : '', showLocalTimeStamp ? 'col-ts' : '']">
                      From
                    </th>
                    <th id="hdr_campaign_status" data-field="subject" data-type="text" @click="sortRecords($event.target)" 
                      class="pb-2 text-nowrap col-c"
                      :class="[(sort.column=='subject') ? sortClass : '', showLocalTimeStamp ? 'col-ts' : '']">
                      Subject Line
                    </th>
                    <th id="hdr_campaign_name" 
                      class="pb-2 text-nowrap col-d nosort d-none d-lg-table-cell d-xl-table-cell">
                      Campaign Info
                    </th>
                    <th v-if="showEmailEvents" id="hdr_activity" data-field="events.activity" data-type="boolean" 
                      class="pb-2 text-nowrap col-de"
                      :class="(sort.column=='events.activity') ? sortClass : '' ">
                      Activity
                    </th>
                    <th class="nosort pb-2 col-e">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>

                  <template v-for="(item,idx) in paginator.pageItems">
                    <tr tabindex="0"
                      @click="setSelectedRecord(item)" 
                      @dblclick.stop="showDetail(item)"
                      v-on:keyup.enter="showDetail(item)"
                      v-on:keydown.down.prevent="selectNextCampaign(idx)"
                      v-on:keydown.up.prevent="selectPreviousCampaign(idx)"
                      :class="{'bg-info': selectedRecord && selectedRecord.uuid == item.uuid}">
                      <td class="col-a" :class="{'col-ts':showLocalTimeStamp}">
                        <span class="wide-popover" :data-content="formatMsgSummary(item)">{{ (item.sent_dt) ? formatDate(item.sent_dt, showLocalTimeStamp) : ''}}</span>
                      </td>
                      <td class="col-b d-none d-lg-table-cell d-xl-table-cell" :class="{'col-ts':showLocalTimeStamp}">
                        <span v-if="item.channel=='d' && item.doc_type=='pdf'">
                          Direct Mail
                        </span>
                        <span v-else>
                          {{ item.from_name }}
                        </span></td>
                      <td class="col-c text-nowrap d-none d-md-table-cell">
                        <span class="d-inline-block text-truncate align-bottom" 
                          style="font-size: .9em;"
                          :class="{'sub-col-evts': showEmailEvents, 'sub-col': !showEmailEvents}"
                          >{{ item.subject }}</span>
                      </td>

                      <td class="col-d d-none d-lg-table-cell d-xl-table-cell">
                        <span v-if="item.channel=='d' && item.doc_type=='pdf'" data-toggle="tooltip"  
                          title="PDF document" 
                          class="small campaign-info-icon d-inline-block text-white mr-md-1 mb-1 mb-lg-0">
                          PDF
                        </span>
                        <span v-if="item.campaign_purpose" data-toggle="tooltip"  
                          :data-original-title="'<b>Type:</b> ' + item.campaign_purpose" 
                          class="small campaign-info-icon d-inline-block text-white mr-md-1 mb-1 mb-lg-0">
                          {{ (item.campaign_purpose)? item.campaign_purpose.substr(0,1) : '' }}
                        </span>
                        <span v-else-if="item.metadata && item.metadata.channel" data-toggle="tooltip"  
                          :data-original-title="'<b>Type:</b> ' + item.metadata.channel" 
                          class="small campaign-info-icon d-inline-block text-white mr-md-1 mb-1 mb-lg-0">
                          {{ getMessageTypeAcronym(item.metadata.channel) }}
                        </span>
                        <span v-else-if="item.metadata && item.metadata.message_type" data-toggle="tooltip"  
                          :data-original-title="'<b>Type:</b> ' + item.metadata.message_type" 
                          class="small campaign-info-icon d-inline-block text-white mr-md-1 mb-1 mb-lg-0">
                          {{ getMessageTypeAcronym(item.metadata.message_type) }}
                        </span>
                        <span v-if="item.marketing_program" data-field="programType"
                          data="text"
                          class="small campaign-info text-white d-inline-block text-white mr-md-1 mb-1 mb-lg-0"
                          >{{item.marketing_program}}</span>
                        <span v-else-if="(item.metadata && item.metadata.keywords)" data-field="programType"
                          data="text"
                          class="small campaign-info text-white d-inline-block text-white mr-md-1 mb-1 mb-lg-0"
                          >{{ formatKeywords(item.metadata.keywords)}}</span>
                      </td>
                      <td v-if="showEmailEvents">
                        <span v-if="item.has_event_data" data-toggle="popover" :data-content="formatEventSummary(item.events)" data-title="Activity" class="d-inline-block" style="min-width: 30px;">
                          <span v-if="item.events.o && item.events.o.length > 0" class="engagement-item d-inline-block mr-1 bg-success"></span>
                          <span v-if="item.events.c && item.events.c.length > 0" class="engagement-item d-inline-block mr-1 bg-primary"></span>
                          <span v-if="item.events.b && item.events.b.length > 0" class="engagement-item d-inline-block mr-1 bg-yellow"></span>
                          <span v-if="(item.events.comp && item.events.comp.length > 0) || (item.events.unsub && item.events.unsub.length > 0)" class="engagement-item d-inline-block mr-1 bg-danger"></span>
                        </span>
                      </td>

                      <td class="text-right col-e">
                        <a class="glyphicons-a mr-1" @click.prevent="showDetail(item)" data-toggle="tooltip" title="View details">
                          <span class="glyphicons glyphicons-zoom-in"></span>
                        </a>
                        <template v-if="privs.RE">
                          <template v-if="privs.RE && item.channel=='e' && subAccountCanResend(item)">
                            <a class="glyphicons-a mr-1" @click.prevent="confirmResend(item)" data-toggle="tooltip" title="Resend message">
                              <span class="glyphicons glyphicons-send"></span>
                            </a>
                          </template>
                          <template v-else>
                            <span  class="glyphicons mr-1">&nbsp;</span>
                          </template>
                        </template>
                        <a v-if="privs.DF || privs.PE || privs.DR" href="#" class="glyphicons-a" style="font-size: 1.1em;" data-toggle="dropdown" aria-haspopup="true"><span class="glyphicons glyphicons-more"></span> </a>&nbsp;
                        <div v-if="privs.DF || privs.PE || privs.DR" class="dropdown-menu dropdown-menu-right">
                          <a v-if="privs.PE" class="dropdown-item" @click="printEmail">
                            <span class="glyphicons glyphicons-print mr-1"></span>Print copy of message
                          </a>
                          <a v-if="privs.DF" target="_blank" class="dropdown-item" :href="'/api/v1/email/'+ encodeURIComponent(item.locator)">
                            <span class="glyphicons glyphicons-disk-export mr-1"></span>Open in New Tab</a>
                          
                          <a v-if="privs.DR" class="dropdown-item" @click="deleteMessage">
                            <span class="glyphicons glyphicons-bin mr-1"></span>Delete message
                          </a>
                          
                          <a v-if="privs.DF" @click.prevent="downloadFile('/api/v1/email/'+ encodeURIComponent(item.locator),(item.doc_type=='pdf')?'PDF file':'HTML email file');trackSubAccountActivity(selectedRecord.sub_account_id,'email_download');trackEmailDownload(selectedRecord);" class="dropdown-item" :href="'/api/v1/email/'+ encodeURIComponent(item.locator)">
                            <span class="glyphicons glyphicons-disk-import mr-1"></span>Download {{(item.doc_type=='pdf')? 'PDF file' : 'HTML file'}}</a>

                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>

              <table v-else 
                id="tableApp" class="table table-hover table-sm campaign-table">
                <thead class="sortable-header sticky-top bg-white" style="z-index:500;">
                  <tr>
                    <th id="hdr_group_name" data-field="sent_dt" data-type="date" @click="sortRecords($event.target)" 
                      class="pb-2 text-nowrap"
                      :class="[(sort.column=='sent_dt') ? sortClass : '', showLocalTimeStamp ? 'col-ts' : '']">
                      Sent
                    </th>
                    <th id="hdr_campaign_status" data-field="subject" data-type="text" @click="sortRecords($event.target)" 
                      class="pb-2 text-nowrap d-none d-md-table-cell"
                      :class="[(sort.column=='subject') ? sortClass : '', showLocalTimeStamp ? 'col-ts' : '']">
                      Subject Line / Details
                    </th>
                    <th class="nosort pb-2 col-e">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>

                  <template v-for="(item,idx) in paginator.pageItems">
                    <tr tabindex="0"
                      @click="setSelectedRecord(item)" 
                      @dblclick.stop="showDetail(item)"
                      v-on:keyup.enter="showDetail(item)"
                      v-on:keydown.down.prevent="selectNextCampaign(idx)"
                      v-on:keydown.up.prevent="selectPreviousCampaign(idx)"
                      :class="{'bg-info': selectedRecord && selectedRecord.uuid == item.uuid}">
                      <td class="wide-popover" :data-content="formatMsgSummary(item)">
                        <span v-if="item.channel=='d' && item.doc_type=='pdf'">
                          Direct Mail
                        </span>
                        <span class="font-weight-semibold" v-else>
                          {{ item.from_name }}
                        </span>

                        <div class="small">{{ (item.sent_dt) ? formatDate(item.sent_dt, true) : ''}}</div>

                      </td>
                      <td class="text-nowrap d-none d-md-table-cell">
                        <span class="d-inline-block sub-col text-truncate" 
                          style="font-size: .9em;"
                          >{{ item.subject }}</span>
                        <div>
                          <span v-if="item.channel=='d' && item.doc_type=='pdf'" data-toggle="tooltip"  
                            title="PDF document" 
                            class="small campaign-info-icon d-inline-block text-white mr-md-1 mb-1 mb-lg-0">
                            PDF
                          </span>
                          <span v-if="item.campaign_purpose" data-toggle="tooltip"  
                            :data-original-title="'<b>Type:</b> ' + item.campaign_purpose" 
                            class="small campaign-info-icon d-inline-block text-white mr-md-1 mb-1 mb-lg-0">
                            {{ (item.campaign_purpose)? item.campaign_purpose.substr(0,1) : '' }}
                          </span>
                          <span v-else-if="item.metadata && item.metadata.channel" data-toggle="tooltip"  
                            :data-original-title="'<b>Type:</b> ' + item.metadata.channel" 
                            class="small campaign-info-icon d-inline-block text-white mr-md-1 mb-1 mb-lg-0">
                            {{ getMessageTypeAcronym(item.metadata.channel) }}
                          </span>
                          <span v-else-if="item.metadata && item.metadata.message_type" data-toggle="tooltip"  
                            :data-original-title="'<b>Type:</b> ' + item.metadata.message_type" 
                            class="small campaign-info-icon d-inline-block text-white mr-md-1 mb-1 mb-lg-0">
                            {{ getMessageTypeAcronym(item.metadata.message_type) }}
                          </span>
                          <span v-if="item.marketing_program" data-field="programType"
                            data="text"
                            class="small campaign-info text-white d-inline-block text-white mr-md-1 mb-1 mb-lg-0"
                            >{{item.marketing_program}}</span>
                          <span v-else-if="(item.metadata && item.metadata.keywords)" data-field="programType"
                            data="text"
                            class="small campaign-info text-white d-inline-block text-white mr-md-1 mb-1 mb-lg-0"
                            >{{ formatKeywords(item.metadata.keywords)}}</span>

                            <span v-if="showEmailEvents && item.has_event_data" data-toggle="popover" :data-content="formatEventSummary(item.events)" data-title="Activity" class="ml-2 d-inline-block" style="min-width: 30px;">
                            <span v-if="item.events.o && item.events.o.length > 0" class="engagement-item d-inline-block mr-1 bg-success"></span>
                            <span v-if="item.events.c && item.events.c.length > 0" class="engagement-item d-inline-block mr-1 bg-primary"></span>
                            <span v-if="item.events.b && item.events.b.length > 0" class="engagement-item d-inline-block mr-1 bg-yellow"></span>
                            <span v-if="(item.events.comp && item.events.comp.length > 0) || (item.events.unsub && item.events.unsub.length > 0)" class="engagement-item d-inline-block mr-1 bg-danger"></span>
                          </span>                            
                        </div>

                      </td>
                      <td class="text-right col-e align-middle">
                        <a class="glyphicons-a mr-1" @click.prevent="showDetail(item)" data-toggle="tooltip" title="View details">
                          <span class="glyphicons glyphicons-zoom-in"></span>
                        </a>
                        <a v-if="privs.DF || privs.PE" href="#" class="glyphicons-a" style="font-size: 1.1em;" data-toggle="dropdown" aria-haspopup="true"><span class="glyphicons glyphicons-more"></span> </a>&nbsp;
                        <div v-if="privs.DF || privs.PE" class="dropdown-menu dropdown-menu-right">
                          <a v-if="privs.PE" class="dropdown-item" @click="printEmail">
                            <span class="glyphicons glyphicons-print mr-1"></span>Print copy of message
                          </a>
                          <a v-if="privs.DF" target="_blank" class="dropdown-item" :href="'/api/v1/email/'+ encodeURIComponent(item.locator)">
                            <span class="glyphicons glyphicons-disk-export mr-1"></span>Open in New Tab</a>
                          
                          <a v-if="privs.DF" @click.prevent="downloadFile('/api/v1/email/'+ encodeURIComponent(item.locator),(item.doc_type=='pdf')?'PDF file':'HTML email file');trackSubAccountActivity(selectedRecord.sub_account_id,'email_download');trackEmailDownload(selectedRecord);" class="dropdown-item" :href="'/api/v1/email/'+ encodeURIComponent(item.locator)">
                            <span class="glyphicons glyphicons-disk-import mr-1"></span>Download {{(item.doc_type=='pdf')? 'PDF file' : 'HTML file'}}</a>

                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          <!-- /campaign table container -->
          <!-- paginator container -->
          <div id="paginator" class="container-fluid">
            <div class="row">
              <div class="col-8 bg-white">
                <template v-if="activeSearch && paginator.pageSizeOptions && recordsLength > paginator.pageSizeOptions[0]">
                  <div style="padding: 10px 0px;">
                    <div class="btn-group dropup mr-1">
                      <input type="text" class="rowsPerPage text-left form-control form-control-sm" data-toggle="dropdown" v-bind:placeholder.stop="paginator.pageSize + ' rows per page'" v-on:keypress.prevent=""/>
                      <ul id="campaignTypeList" class="dropdown-menu">
                        <template v-for="size in paginator.pageSizeOptions">
                          <a href="#" :class="{active: paginator.pageSize==size }" class="dropdown-item" v-on:click.prevent="setPageSize(size)">
                            <span>{{size}}</span> rows</a>
                        </template>
                      </ul>
                    </div>
                    <div class="btn-group">
                      <span class="small">Page <span>{{paginator.pageIndex+1}}</span> of
                        <span>{{paginator.pageCount}}</span>&nbsp;&nbsp;
                        <span v-if="recordsLength == 500" class="text-muted">&horbar;&nbsp;&nbsp;Limited to first {{recordsLength}} records</span> 
                        <span v-else class="text-muted">&horbar;&nbsp;&nbsp;{{recordsLength}} total records</span> 
                      </span>
                    </div>

                    <div class="btn-group float-right pagination pagination-sm">
                      <button v-if="paginator.pageIndex > 0" v-on:click="function() {showPage(paginator.pageIndex - 1)}" class="btn btn-sm btn-outline-indigo">
                        Previous
                      </button>
                      <button v-if="paginator.pageIndex + 1 < paginator.pageCount" v-on:click="function() {showPage(paginator.pageIndex + 1)}" class="btn btn-sm btn-outline btn-outline-indigo">
                        Next
                      </button>
                    </div>
                  </div>
                </template>
              </div>
              <div class="col-4">

              </div>
            </div>
          </div>
          <!-- /paginator container -->
          <!-- search information -->
          <template v-if="false && activeSearch">
            <div class="mt-3">
              <span class="form-group font-light text-muted" v-show="emails.length == 0">
                No records found matching '<span class="font-weight-semibold">TODO</span>' between
                {{moment(searchParams.startDate).format("MM/DD/YYYY")}} and
                {{moment(searchParams.endDate).format("MM/DD/YYYY")}}</span>
              <a href="#" @click.prevent="clearSearchResults">
                Clear search<span class="glyphicons glyphicons-remove ml-1"></span>
              </a>
            </div>
          </template>
          <!-- search information -->
        </div>
        <!-- /campaign table container -->

        <!-- preview panel -->
        <div id="sidePanel" class="col-4">
          <div v-show="loadingEmail" id="emptyPreviewPane">
            <div style="line-height: calc(100vh - 100px);text-align: center;">
              <div class="spinner text-gray">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </div>
          <iframe id="previewPane"
            v-show="!loadingEmail" 
            scrolling="auto"
            @load="setLoadedFrame()"
            :style="{'pointer-events': fullyLoaded || privs.PC ? 'auto' : 'none'}"
            class="preview-pane"></iframe>
          <!--<div class="loading-wait fade-in" :class="{'d-none': fullyLoaded && !loadingEmail}"></div>-->
        </div>
        <!-- /preview panel -->

        <!-- /main content -->
      </div>
      <!-- /main content container -->
    </div>
    <!-- end list view-->

  </div>  
</template>
<script>
import moment from 'moment-timezone'
import {mapState} from 'vuex'
import DateFormatting from '@/mixins/date-formatting'
import Email from '@/mixins/email'
import Event from '@/mixins/event'
import Tracking from '@/mixins/tracking'
import CustomFields from '@/mixins/custom-fields'
const debounce = require("lodash").debounce;

export default {
  mixins: [DateFormatting,Email,Event,Tracking,CustomFields],
  components: {},
  data: function() {return {
      loadingEmail: false,
      fullyLoaded: false,
      scalePct: 1,
    }
  },
  computed: {
    ...mapState({
      uiConfig: (state)=>state.user.uiConfig,
      privs: (state)=>state.user.privs,
      emails: (state)=>state.search.emails,
      loading: (state)=>state.ui.loading,
      activeView: (state)=>state.ui.activeView,
      detailView: (state)=>state.ui.detailView,
      activeSubAccount: (state)=>state.ui.activeSubAccount,
      viewType: (state)=>state.ui.viewType,      
      selectedRecord: (state)=>state.search.selectedEmail,
      activeSearch: (state)=>state.search.activeSearch,
      emailsearchParams: (state)=>state.search.searchParams,
      filterEmail: (state)=>state.search.filterEmail,
      paginator: (state)=>state.search.paginator,
      sort: (state)=>state.search.sort,
      showEmailEvents: (state)=>state.user.showEmailEvents,
    }),
    sortClass(){
      return (this.sort.order=='asc') ? 'sort-down': 'sort-up';
    },
    recordsLength: function() {
      return this.emails.length;
    },
    maxPageIndex: function() {
      return Math.ceil(this.emails.length / this.paginator.pageSize);
    },
    showLocalTimeStamp: function() {
      return (this.uiConfig.account && this.uiConfig.account.config.show_results_timestamp);
    },
    isPersonaView() {
      return this.activeView=='personas';
    }

  }, 
  mounted: function() {
    let that = this;
    
    $('#list_view').tooltip({selector: '[data-toggle="tooltip"]', html:true, trigger: 'hover', delay: { "show": 500, "hide": 100 }});

    $('#list_view').popover({
      //find any elements that have something in data-content
      selector: '[data-toggle="popover"]',
      container: 'body',
      delay: { "show": 500, "hide": 100 },
      html: true,
      trigger: 'hover',
      boundary: 'viewport',
    });

    $('#previewPane').on('load',function() {
      // this is a catch-all to ensure cleanup, final resizing and javascript appending works as expected
      that.setClickSettings();
    });
  },
  updated: function() {
    $('#list_view').popover('hide');
    $('.wide-popover').popover('hide');

    $('.wide-popover').popover({
      container: 'body',
      delay: { "show": 500, "hide": 100 },
      html: true,
      trigger: 'hover',
      boundary: 'viewport',
      template:
        '<div class="popover popover-wide popover-dark" role="tooltip" style="max-width: 400px!important;"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });

  },
  methods: {
    resizePreviewPane: debounce(function(){this.sizePreviewPane()},100),
    sizePreviewPane(){
      console.log("sizePreviewPane");
      this.scalePreviewPane();
      
    },
    setLoadedFrame() {
      this.scalePreviewPane();
    },
    setPageSize(pageSize) {
      this.$store.commit("setPageSize",pageSize)
    },
    showPage(newPageIndex) {
      this.$store.commit("setPageIndex",newPageIndex);
    },
    setSelectedRecord(email){
      this.$store.commit("setSelectedEmail",email);
    },
    selectNextCampaign(index) {
      if (index < this.paginator.pageItems.length -1) {
        this.setSelectedRecord(this.paginator.pageItems[index+1]);
        $("#tableApp tbody tr")[index+1].focus();
      } else if (this.paginator.pageIndex < this.maxPageIndex-1) {
        this.showPage(this.paginator.pageIndex+1);
        this.$nextTick(()=>{
          this.setSelectedRecord(this.paginator.pageItems[0]);
          $("#tableApp tbody tr")[0].focus();
        });
      }
    },
    selectPreviousCampaign(index) {
      if (index > 0) {
        this.setSelectedRecord(this.paginator.pageItems[index-1]);
        $("#tableApp tbody tr")[index-1].focus();
      } else if (this.paginator.pageIndex > 0) {
        this.showPage(this.paginator.pageIndex-1);
        this.$nextTick(()=>{
          this.setSelectedRecord(this.paginator.pageItems[this.paginator.pageSize-1]);
          $("#tableApp tbody tr")[this.paginator.pageSize-1].focus();            
        });
      }        
    },
    scalePreviewPane(){
      console.log("scalePreviewPane")
      var iframe = document.getElementById('previewPane');
      this.loadPrintFrame('printFrame',iframe.src,'list_container');
      let that = this;
                      
      if ((this.selectedRecord) && this.selectedRecord.doc_type!='pdf') {
        this.setMasks(iframe,true);

        var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
        iframeDocument.getElementsByTagName("body")[0].style.paddingBottom='25px';
        let frameWidth = 660;

        iframe.style.width = '200px'; // we do this to ensure we can get a measurement for scrollWidth below
        if ($('#sidePanel').width() < iframeDocument.body.scrollWidth) {
          frameWidth = iframeDocument.body.scrollWidth + 10;
        }
        this.resizeFrame(frameWidth);
        
        setTimeout(()=>{
          that.setClickSettings();
        },500);
        
      } else {
        iframe.style.width = '200px';
        let frameWidth = $('#sidePanel').width();
        this.resizeFrame(frameWidth);
      }
      iframe.style.opacity = 1;
      setTimeout(()=>{that.loadingEmail = false;}, 500);
      
    },
    getMessageTypeAcronym(msgType) {
      var matches = msgType.match(/\b(\w)/g); // create array of first letter for each word
      if (matches.length) {
        return matches.join('').toUpperCase(); // combine and return first letters 
      } else {
        return ""
      }      
    },
    formatKeywords(keywords) {
      try {
        return keywords.split(" ")[0];
      } catch(e) {
        console.warn(e);
      }
      
    },
    formatMsgSummary(msg) {
      let ret = `<div class="popSummary">`;

      ret += this.formatPopField(msg,'campaign_name','Campaign Name');

      ret += `<div><b>Recipient:</b> ${msg.email}</div>
              <div><b>Sent on:</b> ${this.formatDate(msg.sent_dt, false, true)}</div>
              <div><b>Sent from:</b> ${msg.from_email}</div>
              <div><b>Sender name:</b> ${msg.from_name}</div>
              <hr>
              <div><b>Subject:</b><br>${msg.subject}</div>`

      let optionalFields = "";

      optionalFields += this.formatPopField(msg,'campaign_purpose','Type');
      optionalFields += this.formatPopField(msg,'marketing_program','Marketing Program');
      optionalFields += this.formatPopField(msg,'marketing_strategy','Marketing Strategy');

      if (optionalFields.length) {
        ret += "<hr>" + optionalFields;
        optionalFields = "";
      }

      for (let filter of this.advancedFilters) {
        if (filter.name!='campaign_name') {

          //console.log(filter);
          //<span class="font-weight-semibold">{{filter.displayName}}:&nbsp;</span>
          if (filter.type=='custom') {
            if ((!filter.v2) && (msg[filter.column_name] != null)) {
              optionalFields += this.formatPopField(msg,filter.column_name,filter.displayName);
            } else if (filter.v2 && (msg[filter.name] != null)) {
              optionalFields += this.formatPopField(msg,filter.name,filter.displayName);
            }
          } else if (msg.metadata) {
            if (msg.metadata[filter.name]) {
              optionalFields += this.formatPopField(msg,filter.name,filter.displayName,true);
            }
          }
        }
      }

      // finally, check for any metadata values not setup at account level, and consequently not in advancedFilters
      if (msg.metadata) {
        for (const key in msg.metadata) {
          if (!this.uiConfig.metadata_fields.find(s=>s.name == key) && key!='campaign_name') {
            optionalFields += this.formatPopField(msg,key,this.prettifyCaption(key),true);
          }
        }
      }

      if (optionalFields.length) {
        ret += "<hr>" + optionalFields;
      }

      ret += "</div>";

      return ret;
    },
    formatPopField(msg,field,displayName,metaOverride) {
      if (msg[field] && !metaOverride) {
        return `<div><b>${displayName}:</b> ${msg[field]}</div>`
      } else if (msg.metadata && msg.metadata[field]) {
        return `<div><b>${displayName}:</b> ${msg.metadata[field]}</div>`
      } else {
        return ""
      }
    },
    getFrameHeight() {
      var iframe = document.getElementById('previewPane');
      var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      var priorHeight = iframeDocument.body.scrollHeight; // get current height before resizing happens
      setTimeout(()=>{ 
        var curHeight = iframeDocument.body.scrollHeight;
        var calcHeight = 1500;
        if (curHeight!==0) {
          calcHeight = curHeight;
        } else if (priorHeight!=0) {
          calcHeight = priorHeight;
        }
        //iframe.style.height = (calcHeight/scalePct) + 'px';
        //console.log(`prior height: ${priorHeight}\nheight: ${curHeight}\ncurrent: ${calcHeight}`);
      },1750);
    },
    setClickSettings() {
      let that = this;
      var iframe = document.getElementById('previewPane');
      var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      
      try {
        if (!that.privs.PC) {
          $(iframe.contentWindow.document.body).on('click', function(e) {
              return false;
          });
          iframe.contentWindow.document.body.addEventListener("contextmenu", function(e){
            e.preventDefault();
          }, false);
        } else {
          $(iframe.contentWindow.document.body).contents().find('a').attr('target','_new');
        }
        that.fullyLoaded = true;
      } catch(e) {
        console.warn(e);
      }
    },

    resizeFrame(eWidth) {
      let previewFrame = document.getElementById('previewPane');
      previewFrame.style.width = eWidth + 'px';

      var ifWidth = $('#sidePanel').width();
      let scalePct = ((this.selectedRecord) && this.selectedRecord.doc_type!='pdf') ? ifWidth/eWidth : 1;
      this.scalePct = scalePct;
      
      $('#emptyPreviewPane').height('calc(100vh - 120px)');
      previewFrame.style.height = ($('#emptyPreviewPane').height()/scalePct) + 'px';
      
      if (eWidth>=ifWidth) {
        //previewFrame.style.transition=`transform 75ms`;
        /*previewFrame.style.msTransform='scale('+scalePct+')';
        previewFrame.style.msTransformOrigin='0% 0%';
        previewFrame.style.webkitTransform='scale('+scalePct+')';
        previewFrame.style.webkitTransformOrigin='0% 0%';*/
        previewFrame.style.transform='scale('+scalePct+')';
        previewFrame.style.transformOrigin='0% 0%';          
      }
      
    },

    deleteMessage() {
      this.$parent.$refs.searchBar.confirmDelete('selected');
    },

    printEmail() {
      var iframe = document.getElementById('printFrame');
      if (this.selectedRecord.channel=='d') {
        iframe.contentWindow.print();
        this.trackSubAccountActivity(this.selectedRecord.sub_account_id,"email_print");
        let props = {
          sub_account_id: this.selectedRecord.sub_account_id,
        }
        this.$store.dispatch("track",{name:"email_print",props:props})
      } else {
        var whenReady = function(callback) {
          try {
            let state = iframe.contentWindow.document.readyState;
            if (state === 'complete' || state === 'interactive') {
              callback('readyState: ' + state); // check not already loaded prior to this function being called
            } else if (document.addEventListener) {
              document.addEventListener('DOMContentLoaded', callback); // for standards compliant browsers (including IE 9+)
            }
          } catch(e) {
            console.warn(e);
          }
        };

        whenReady(()=>{
          var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
          iframe.style.height = iframeDocument.body.scrollHeight + 'px'

          window.print();
          this.trackSubAccountActivity(this.selectedRecord.sub_account_id,"email_print");
          let props = {
            sub_account_id: this.selectedRecord.sub_account_id,
          }
          this.$store.dispatch("track",{name:"email_print",props:props})
        });
      }
      
    },
    setActiveView(name){
      $('[data-toggle="tooltip"]').tooltip('hide');      
      this.$store.commit("setActiveView",name);
    },
    showDetail(email) {
      this.setSelectedRecord(email);
      this.$store.commit("setResendChange",false);
      let view = (this.activeView=='search') ? 'detail' : 'persona-detail'
      this.setActiveView(view);
    },
    confirmResend(email) {
      this.$parent.$refs.resendEmail.show(email)
    },
    sortRecords(colElement){
      const column = $(colElement).data('field');
      var order = 'asc';
      if (this.sort.column == column) {
        order = (this.sort.order == 'asc') ? 'desc' : 'asc' 
      }
      this.$store.dispatch('sortFilteredResults',{column: column,order:order});
    },
    subAccountCanResend(emailRecord){
      let subAccountId = emailRecord.sub_account_id
      let canResend = false;
      if (this.uiConfig.sub_accounts){
        let subAccount = this.uiConfig.sub_accounts.find(s=>s.id == subAccountId)
        canResend = subAccount.can_resend;
        if (canResend){
          let platformConfig = subAccount.platform_configs[subAccount.resend_platform_id];
          if (platformConfig){
            let resendRequiredField = platformConfig.config.resend_required_field;
            if (resendRequiredField){
              if (! emailRecord[resendRequiredField]){
                canResend = false;
              }
            }
          }
        }
      }
      return canResend;
    },
    trackEmailDownload(email){
      let props = {
        sub_account_id: email.sub_account_id,
      }
      this.$store.dispatch("track",{name:"email_download",props:props})
    },
  },
  watch: {
    'selectedRecord': async function() {
      let previewPane = document.getElementById('previewPane');
      if (this.selectedRecord && this.selectedRecord.locator) {
        let that = this;
        let url = null;
        this.loadingEmail = true;
        this.fullyLoaded = false;
        if (this.selectedRecord.metadata?.pdf2){
          try {
            url = await this.$store.dispatch("extractPdf2",{});
            if (!url){
              return;
            }
          } catch (err){
            console.log(err)
            this.loadingEmail = false;
            previewPane.style.opacity = 1;
            return
          }
        } else {
          url = this.getEmailUrl(this.selectedRecord);
        }
        previewPane.style.opacity = 0;
        previewPane.src = url; 
        this.resizeFrame(660); // do this to reset baseline width 
        if (this.selectedRecord.doc_type != "pdf"){
          //this will scale the preview pane and turn off graphic when the html is loaded.
          //this isn't necessary for pdf, where this will happen on the load event on the iframe
          this.iframeReady2("previewPane", ()=>{ that.scalePreviewPane()})
        }

      } else {
        previewPane.src = '';
      }
    },
    'activeView': function(newVal, oldVal) { // needed after detail pane closes
      if ((newVal=='search' || newVal=='personas') && this.selectedRecord) {
        this.scalePreviewPane();
      }
    },
    'viewType': function(newVal, oldVal) { // needed after journey view closes
      if (newVal=='list' && this.selectedRecord) {
        this.scalePreviewPane();
      }
    },
  },
}
</script>
<style>
@media screen {

  #printFrame {
    z-index: -500;
    position: absolute;
    opacity: 0;
    width:  100vw;
    top: -50000px;
  }
}

@media print {
  #printFrame.hidden {
    display: none!important;
    visibility: hidden!important;
    left: -1200px;
  }
  #printFrame {
    break-before: avoid!important;
    display: inline-block;
    position: relative;
    padding-top: 0px;
    overflow: visible;
    visibility: visible!important;
    opacity: 1;
    width: 100%;
    border: none;
  }

}
</style>

<style scoped>
.preview-pane {
  border: 0px;
  width: 100%;
  height: calc(100vh - 120px);
  position: fixed;
  overflow-y: auto;
  overflow-x: hidden;
}

#emptyPreviewPane {
}
.col-a {
  min-width: 95px;
}
.col-a.col-ts {
  min-width: 155px;
}
td.col-a.col-ts, td.col-b.col-ts{
  font-size: .9em;
  vertical-align: middle;
}
.col-b {
  min-width: 160px;
}
.col-b.col-ts {
  min-width: 150px;
}
.col-c {
}
.col-d {
  min-width: 150px;
}
.col-de {
  min-width: 75px;
  max-width: 75px!important;
}
.col-e {
  min-width: 75px;
  max-width: 75px!important;
}

.sub-col-evts {
  max-width: calc(100vw * .55 - 475px);
}

.sub-col {
  max-width: calc(100vw * .55 - 400px);
}

@media (max-width: 993px) { 
  .sub-col {
    max-width: calc(100vw * .55 - 200px);
  }
  .sub-col-evts {
    max-width: calc(100vw * .55 - 275px);
  }
  .col-c {
    min-width: 100px!important;
  }

}


#sidePanel {
  overflow-y: visible;
}

.popover.popover-dark .popover-header {
  background-color: #195d6e;
  color: #fff;
}

.popover.popover-dark .popover-body {
  background-color: #343a40;
  color: #ffffff;  
}

.popover.popover-dark.bs-popover-top > .arrow::after {
    border-top-color: #343a40!important;
}

.popover.popover-dark.bs-popover-right > .arrow::after {
    border-right-color: #343a40!important;
}

.popover.popover-dark.bs-popover-bottom > .arrow::after {
    border-bottom-color: #343a40!important;
}

.popover.popover-dark.bs-popover-left > .arrow::after {
    border-left-color: #343a40!important;
}

.loading-wait {
  position: relative;
  z-index: 10;
  top: calc(100vh - 118px);
  height: 6px;
  background: linear-gradient(to right, transparent 15%, var(--primary) 35%, var(--indigo) 60%, transparent 80%);
  background-size: 600% 600%;
  -webkit-animation: AnimationName 4s ease infinite;
  -moz-animation: AnimationName 4s ease infinite;
  animation: AnimationName 4s ease infinite;
}
@-webkit-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}
@keyframes AnimationName { 
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}

.print-header {
  display: none;
}

@media print {
  #list_container {
    display: inline-block;
    position: relative;
  }

  .print-header {
    display: inline-block;
    break-before: avoid;
    break-after: avoid-page;
    margin-left: 10px;
    margin-bottom: 0px;
    padding-bottom:0px;
    margin-top: -20px
  }
}

.tbody-scroll {
  display: block;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
}
</style>